import Component from "../../component";

const StageComponentConfig = {
    baseHtmlClass: 'nav_menu_stage',
    selector: '.nav_menu_stage'
};

export default class StageComponent extends Component {

    // The .nav_menu_stage element should be the parent of the .nav_menu but is selected according to its class.
    static new(navMenu) {
        if (!navMenu.element) return null;
        let element = document.querySelector(`${ StageComponentConfig.selector}--${ navMenu.id }`)
        if (!element) return null;
        return new StageComponent(element, navMenu);
    }

    constructor(id_or_element, navMenu) {
        super({
            element: id_or_element,
            config: StageComponentConfig
        });

        this.navMenu = navMenu;
        this.element.addEventListener('click', this.handleClick.bind(this));
        this.listening = true;
    }

    handleClick(event) {
        if (this.element === event.target) { this.navMenu.open = false }

        if (this.listening) {
            window.requestAnimationFrame(()=>{
                this.navMenu.render();
                this.listening = true;
            });
            this.listening = false;
        }
        event.stopPropagation();
        // event.preventDefault();
    }

    state() {
        return this.navMenu.state();
    }

    render() {
        this.conditionallySetHtmlClassState(this.state().open, 'open');
    }

}